<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="visibleSync"
    width="600px"
    :close-on-click-modal="false"
    v-el-dialog-drag
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      label-width="110px"
      size="small"
    >
      <el-form-item
        :label="$l('form_label_workshop_name') || '车间名称'"
        prop="workshopName"
      >
        <el-input
          v-model.trim="form.workshopName"
          :placeholder="
            $l('form_placeholder_workshop_name') || '请输入车间名称'
          "
          maxlength="100"
          show-word-limit
        />
      </el-form-item>

      <el-form-item :label="$l('form_label_remark') || '备注'">
        <el-input
          v-model.trim="form.remark"
          type="textarea"
          :rows="3"
          :placeholder="$l('form_placeholder_remark') || '请输入备注'"
          maxlength="200"
          show-word-limit
        />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button size="small" type="primary" :loading="saving" @click="save">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'inspection-workshop-edit-dialog',
  props: {
    visible: { type: Boolean, default: false },
    data: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      form: {
        inspectionWorkshopCode: '',
        workshopName: '',
        workshopStatus: 'Y',
        remark: '',
      },
      rules: {
        workshopName: [
          {
            required: true,
            message:
              this.$l('tips_workshop_name_required') ||
              '车间名称不能为空',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible
      },
      set(v) {
        this.$emit('update:visible', v)
      },
    },
    isEdit() {
      return !!this.data?.inspectionWorkshopCode
    },
    dialogTitle() {
      return this.isEdit
        ? this.$l('dialog_title_edit') || '编辑车间'
        : this.$l('dialog_title_add') || '新增车间'
    },
  },
  watch: {
    visible(val) {
      if (!val) return
      this.resetForm()
    },
  },
  methods: {
    resetForm() {
      const row = this.data || {}
      const isNew = !row.inspectionWorkshopCode
      this.form = {
        inspectionWorkshopCode: row.inspectionWorkshopCode || '',
        workshopName: row.workshopName || '',
        workshopStatus: isNew ? 'Y' : row.workshopStatus || 'Y',
        remark: row.remark || '',
      }
      this.$nextTick(() => this.$refs.form?.clearValidate?.())
    },
    close() {
      this.visibleSync = false
    },
    async save() {
      if (!this.$refs.form) return
      const ok = await this.$refs.form
        .validate()
        .then(() => true)
        .catch(() => false)
      if (!ok) return

      this.saving = true
      const res = await this.$api
        .dfInspectionWorkshopSaveApi({ ...this.form })
        .catch(() => null)
      this.saving = false

      if (!res) return
      const { status, msg } = res
      const error = status !== 200
      this.$message({
        showClose: true,
        message:
          msg ||
          (error
            ? this.$l('tips_save_failed') || '保存失败'
            : this.$l('tips_save_success') || '保存成功'),
        type: error ? 'error' : 'success',
      })
      if (error) return

      this.close()
      this.$emit('saved')
    },
  },
}
</script>

<style lang="scss" scoped></style>

